import styled from "styled-components";

/* Styles */
import { STYLES } from "@vita-learning/styles";

interface InputLabelProps {
	readonly $required: boolean;
}

export const InputLabel = styled.label<InputLabelProps>`
	font-size: ${STYLES.fonts.sizes.text};
	margin: ${STYLES.spacings.xs} 0;

	${({ $required }) =>
		$required &&
		`
		&:after {
			content: "*";
			color: red;
		}
	`}
`;
